module.exports = __webpack_public_path__ + "img/upload.e89f40d4.png";